// @flow
import {
  GET_SOFTWARE_LIST,
  UPDATE_SOFTWARE_ITEM,
  GET_SOFTWARE_COMPANIES,
  GET_SOFTWARE_USERS
} from "../../global/actions/actionNames";

const initialState: * = {
  softwares: null,
  companies: null,
  users: null
};

const softwareReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case GET_SOFTWARE_LIST:
      if (actions.softwares !== null) {
        const softwares = actions.softwares;
        return {
          ...state,
          softwares: softwares
        };
      }
      return state;

    case UPDATE_SOFTWARE_ITEM:
      if (actions.software !== null && actions.software.id !== null) {
        let softwares = [...state.softwares];
        let index = softwares.findIndex(x => x.id === actions.software.id);

        if (index > -1) {
          softwares[index] = actions.software;
        } else {
          softwares.push(actions.software);
        }

        return {
          ...state,
          softwares: softwares
        };
      }
      return state;

    case GET_SOFTWARE_COMPANIES:
      if (actions.companies !== null) {
        const companies = actions.companies;
        return {
          ...state,
          companies: companies
        };
      }

    case GET_SOFTWARE_USERS:
      if (actions.users !== null) {
        const users = actions.users;
        return {
          ...state,
          users: users
        };
      }
      return state;

    default:
      return state;
  }
};

export default softwareReducers;
